<template>
  <router-link
    :to="{name: 'group_detail', params: {id: group}}"
  >
    <img
      v-if="groupDetails && groupDetails.icon_url"
      :src="groupDetails.icon_url"
      :style="styleAttr"
      :alt="groupDetails.name"
      :title="groupDetails.name"
    >
    <div
      v-else
      :style="styleAttr"
      :title="groupDetails.name"
    >
      <account-multiple-icon
        :title="groupDetails.name"
      />
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    group: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 36,
    },
  },
  data() {
    return {
      avatarUrl: '',
    };
  },
  computed: {
    styleAttr() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'font-size': `${this.size}px`,
      };
    },
    groupDetails() {
      return this.userGroups.find(g => g.id === this.group);
    },
  },
};
</script>

<style lang="scss" scoped>
  img,
  div {
    border-radius: 0.25rem;
    vertical-align: middle;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  }

  div {
    display: inline-block;
    background-color: #fff;
  }

  .material-design-icon > .material-design-icon__svg {
    position: static;
    color: var(--gray-darker);
  }
</style>
